import React, { useState, useRef, useEffect } from 'react';
import { Map, TileLayer, FeatureGroup, GeoJSON } from 'react-leaflet';
import { Popup } from 'react-leaflet';

import { EditControl } from 'react-leaflet-draw';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import proj4 from 'proj4';
import L from 'leaflet';
import { Form, Input, Button,Spin,Select,DatePicker, Divider, Card, message } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
var CryptoJS = require("crypto-js");

const FormItem=Form.Item;

const SpartialData = (props) => {
    const [shapes, setShapes] = useState([]);

    // Helper function to convert WKT to GeoJSON
    const parseGeometry = (wkt) => {
        // Remove SRID=XXXX; prefix if present
        const wktWithoutSrid = wkt.replace(/SRID=\d+;/, '');
    
        let coordinates = [];
    
        if (wktWithoutSrid.startsWith('POLYGON')) {
            // Handle POLYGON geometry
            coordinates = wktWithoutSrid
                .replace('POLYGON ((', '')
                .replace('))', '')
                .split(', ')
                .map(pair => pair.split(' ').map(Number)); // Convert to number
    
            return {
                type: 'Polygon',
                coordinates: [coordinates] // GeoJSON expects a nested array for polygons
            };
        } else if (wktWithoutSrid.startsWith('LINESTRING')) {
            // Handle LINESTRING geometry (for polylines)
            coordinates = wktWithoutSrid
                .replace('LINESTRING (', '')
                .replace(')', '')
                .split(', ')
                .map(pair => pair.split(' ').map(Number)); // Convert to number
    
            return {
                type: 'LineString',
                coordinates: coordinates // GeoJSON format for LineString
            };
        }
    
        throw new Error('Unsupported WKT geometry type');
    };
    

     // Function to bind popups with shape information
     const onEachFeature = (feature, layer) => {
        if (feature.properties) {
            layer.bindPopup(`
                <strong>Description:</strong>Area:  ${feature.properties.calculated_area} Km2 & length: ${feature.properties.length} Km<br />
                <strong>Licence ID :</strong> ${feature.properties.licence_code}<br />
                <strong>Area:</strong> ${feature.properties.calculated_area} Km2<br />
                <strong>Length:</strong> ${feature.properties.length} meters<br />
           
                <strong>Status:</strong> ${feature.properties.license__status} <br />
                <strong>Grant Date:</strong> ${feature.properties.license__grant_date} <br />
                <strong>Expiry Date:</strong> ${feature.properties.licence_expiry_date} <br />

           
                `);
        }
    };


    // Fetch shapes for the licence
    useEffect(() => {
        axios.get(serverconfig.backendserverurl+`/customqueries/application_spartial_data/${props.application_id}/`)
            .then(response => {

                //setShapes(response.data);
                console.log('API Response:', JSON.stringify(response.data.data)); // Debugging
                // Ensure data is an array; if it's a FeatureCollection, extract the features array
                const features = response.data.data.features.map(feature => ({
                    ...feature,
                    geometry: parseGeometry(feature.geometry) // Convert WKT to GeoJSON
                }));
                setShapes(features);


            })
            .catch(error => {
                console.error('Error fetching shapes', error);
            });

        }, [props.application_id]);

    return (
        <Map center={[1.3733, 32.2903]} zoom={7} style={{ height: '500px', width: '100%' }}>
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap contributors"
            />
           {shapes.length > 0 && (
                <GeoJSON
                    data={{ type: 'FeatureCollection', features: shapes }}
                    onEachFeature={onEachFeature}

                    style={(feature) => ({
                        fillColor: feature.properties.spartial_shape_background_color || '#3388ff', // Default fill color
                        color: feature.properties.spartial_shape_border_color || '#000000', // Default border color
                        weight: 2, // Border thickness
                        opacity: 1, // Border opacity
                        fillOpacity: 0.7, // Fill opacity
                    })}
                    
                />
            )}
        </Map>
    );

};

export default SpartialData;
